import { createContext } from 'react';
import { PipelineInterface } from '@/interfaces/Pipeline.interface';
import { PipelineStageInterface } from '@/interfaces/PipelineStage.interface';

interface PipelineContextInterface {
  pipeline?: PipelineInterface;
  isPipelineLoading: boolean;
  pipelineStages?: PipelineStageInterface[];
  isPipelineStagesLoading: boolean;
  refreshPipeline: () => void;
  refreshPipelineStages: () => void;
}

const PipelineContext = createContext<PipelineContextInterface>({
  pipeline: undefined,
  isPipelineLoading: false,
  pipelineStages: undefined,
  isPipelineStagesLoading: false,
  refreshPipeline: () => {},
  refreshPipelineStages: () => {}
});

export default PipelineContext;
